var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showLoader)?_c('div',{staticClass:"spinner bg-white"},[_c('div',[_c('b-spinner',{staticClass:"loader",attrs:{"variant":"main","type":"grow","label":"Spinning"}})],1)]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }